import type { Room } from '@hollowveil/shared';

export const roomShadowTemple: Room = {
      id: 'room_shadow_temple',
      name: "Le Temple des Ombres",
      description: "Un temple ancien où les ombres dansent. Les gardiens des deux mondes gardent le secret de la séquence.",
      size: [30, 14, 30],
      floorStyle: 'temple',
      ambiance: {
        realWorld: {
          backgroundColor: '#2c1810',
          ambientLightColor: '#8b4513',
          ambientLightIntensity: 0.4,
        },
        spectralWorld: {
          backgroundColor: '#0a0a15',
          ambientLightColor: '#4a0080',
          ambientLightIntensity: 0.3,
        },
      },
      objects: [
        // Temple pillars
        {
          id: 'obj_temple_pillar_1',
          name: 'Pilier du Temple',
          type: 'static',
          modelId: 'pillar',
          position: [2, 0, 2],
          rotation: [0, 0, 0],
          scale: [1.2, 1.5, 1.2],
          visibleInWorld: 'both',
          interactableInWorld: 'both',
          properties: { height: 6 },
        },
        {
          id: 'obj_temple_pillar_2',
          name: 'Pilier du Temple',
          type: 'static',
          modelId: 'pillar',
          position: [14, 0, 2],
          rotation: [0, 0, 0],
          scale: [1.2, 1.5, 1.2],
          visibleInWorld: 'both',
          interactableInWorld: 'both',
          properties: { height: 6 },
        },
        {
          id: 'obj_temple_pillar_3',
          name: 'Pilier du Temple',
          type: 'static',
          modelId: 'pillar',
          position: [2, 0, 14],
          rotation: [0, 0, 0],
          scale: [1.2, 1.5, 1.2],
          visibleInWorld: 'both',
          interactableInWorld: 'both',
          properties: { height: 6 },
        },
        {
          id: 'obj_temple_pillar_4',
          name: 'Pilier du Temple',
          type: 'static',
          modelId: 'pillar',
          position: [14, 0, 14],
          rotation: [0, 0, 0],
          scale: [1.2, 1.5, 1.2],
          visibleInWorld: 'both',
          interactableInWorld: 'both',
          properties: { height: 6 },
        },
        // First Guardian - Real World (gives hint: "commence par le nord")
        {
          id: 'obj_guardian_1',
          name: 'Premier Gardien',
          type: 'interactive',
          modelId: 'sage',
          position: [4, 0, 4],
          rotation: [0, Math.PI / 4, 0],
          scale: [1.2, 1.2, 1.2],
          visibleInWorld: 'real',
          interactableInWorld: 'real',
          properties: {},
          onInteract: [
            {
              type: 'showRiddle',
              params: {
                riddle: {
                  id: 'riddle_guardian_1',
                  npcId: 'obj_guardian_1',
                  npcName: 'Premier Gardien',
                  question: '"Voyageur, je suis le Gardien du Jour.\n\nLa séquence commence là où le soleil se lève peu.\nLe NORD est le premier pas.\n\nMais attention, le second pas appartient à mon frère de l\'ombre.\nVa le trouver dans l\'autre monde."',
                  type: 'multiple_choice',
                  choices: [
                    { id: 'a', text: 'J\'ai compris, merci Gardien', isCorrect: true },
                    { id: 'b', text: 'Répétez s\'il vous plaît', isCorrect: false },
                  ],
                  correctResponse: '"Bien. N\'oublie pas : NORD en premier. Mon frère spectral t\'attend."',
                  incorrectResponse: '"Le NORD. Commence par le NORD. C\'est tout ce que tu dois retenir."',
                  canRetry: true,
                },
              },
            },
          ],
        },
        // Second Guardian - Spectral World (gives hint: "puis l'est, enfin l'ouest")
        {
          id: 'obj_guardian_2',
          name: 'Second Gardien',
          type: 'interactive',
          modelId: 'spectral_remnant',
          position: [12, 0, 4],
          rotation: [0, -Math.PI / 4, 0],
          scale: [1.3, 1.3, 1.3],
          visibleInWorld: 'spectral',
          interactableInWorld: 'spectral',
          properties: {},
          onInteract: [
            {
              type: 'showRiddle',
              params: {
                riddle: {
                  id: 'riddle_guardian_2',
                  npcId: 'obj_guardian_2',
                  npcName: 'Second Gardien',
                  question: '"Je suis le Gardien de la Nuit.\n\nMon frère t\'a dit le premier pas.\nMaintenant écoute : après le NORD,\nva vers l\'EST où le soleil naît,\npuis termine à l\'OUEST où il meurt.\n\nNORD, EST, OUEST. Dans cet ordre."',
                  type: 'multiple_choice',
                  choices: [
                    { id: 'a', text: 'NORD, EST, OUEST - J\'ai compris', isCorrect: true },
                    { id: 'b', text: 'Je ne suis pas sûr...', isCorrect: false },
                  ],
                  correctResponse: '"Parfait. Les dalles t\'attendent. Active-les dans l\'ordre : NORD, EST, OUEST."',
                  incorrectResponse: '"NORD d\'abord, puis EST, enfin OUEST. La séquence du soleil."',
                  canRetry: true,
                },
              },
            },
          ],
        },
        // Pressure Plate NORTH (first in sequence)
        {
          id: 'obj_plate_1',
          name: 'Dalle du Nord',
          type: 'trigger',
          modelId: 'block',
          position: [8, 0, 3],
          rotation: [0, 0, 0],
          scale: [2, 0.15, 2],
          visibleInWorld: 'both',
          interactableInWorld: 'real',
          properties: { variant: 'accent' },
          onInteract: [
            {
              type: 'showMessage',
              params: {
                message: 'La Dalle du Nord s\'illumine ! Un son grave résonne dans le temple...',
              },
            },
          ],
        },
        // Pressure Plate EAST (second in sequence)
        {
          id: 'obj_plate_2',
          name: 'Dalle de l\'Est',
          type: 'trigger',
          modelId: 'block',
          position: [13, 0, 8],
          rotation: [0, 0, 0],
          scale: [2, 0.15, 2],
          visibleInWorld: 'both',
          interactableInWorld: 'real',
          properties: { variant: 'accent' },
          onInteract: [
            {
              type: 'showMessage',
              params: {
                message: 'La Dalle de l\'Est s\'illumine ! Un second son résonne...',
              },
            },
          ],
        },
        // Pressure Plate WEST (third in sequence) - triggers door opening
        {
          id: 'obj_plate_3',
          name: 'Dalle de l\'Ouest',
          type: 'trigger',
          modelId: 'block',
          position: [3, 0, 8],
          rotation: [0, 0, 0],
          scale: [2, 0.15, 2],
          visibleInWorld: 'both',
          interactableInWorld: 'real',
          properties: { variant: 'accent' },
          onInteract: [
            {
              type: 'showMessage',
              params: {
                message: 'La Dalle de l\'Ouest complète la séquence ! La porte du sanctuaire s\'ouvre !',
              },
            },
            {
              type: 'openDoor',
              params: {
                doorId: 'obj_shadow_door',
              },
            },
          ],
        },
        // Central altar
        {
          id: 'obj_shadow_altar',
          name: 'Autel des Ombres',
          type: 'static',
          modelId: 'block',
          position: [8, 0, 8],
          rotation: [0, Math.PI / 4, 0],
          scale: [2, 1, 2],
          visibleInWorld: 'both',
          interactableInWorld: 'both',
          properties: { variant: 'stone' },
        },
        // Shadow door blocking the treasure
        {
          id: 'obj_shadow_door',
          name: 'Porte du Sanctuaire',
          type: 'static',
          modelId: 'animated_door',
          position: [8, 0, 13],
          rotation: [0, 0, 0],
          scale: [1.5, 1.5, 1],
          visibleInWorld: 'both',
          interactableInWorld: 'both',
          properties: {},
        },
        // Shadow Key - the reward
        {
          id: 'obj_shadow_key',
          name: 'Clé des Ombres',
          type: 'interactive',
          modelId: 'orb',
          position: [8, 0.5, 14.5],
          rotation: [0, 0, 0],
          scale: [0.8, 0.8, 0.8],
          visibleInWorld: 'both',
          interactableInWorld: 'both',
          properties: {},
          onInteract: [
            {
              type: 'addToInventory',
              params: {
                itemId: 'shadow_key',
                itemName: 'Clé des Ombres',
                itemDescription: 'Une clé forgée dans les ténèbres. Elle peut ouvrir les passages les plus sombres.',
                itemIcon: 'key',
              },
            },
            {
              type: 'showMessage',
              params: {
                message: 'Tu as obtenu la Clé des Ombres ! Les ténèbres te reconnaissent.',
              },
            },
            {
              type: 'hideObject',
              params: {
                objectId: 'obj_shadow_key',
              },
            },
          ],
        },
        // Decorative orbs
        {
          id: 'obj_shadow_orb_1',
          name: 'Orbe d\'Ombre',
          type: 'static',
          modelId: 'orb',
          position: [4, 2, 8],
          rotation: [0, 0, 0],
          scale: [0.6, 0.6, 0.6],
          visibleInWorld: 'spectral',
          interactableInWorld: 'spectral',
          properties: {},
        },
        {
          id: 'obj_shadow_orb_2',
          name: 'Orbe d\'Ombre',
          type: 'static',
          modelId: 'orb',
          position: [12, 2, 8],
          rotation: [0, 0, 0],
          scale: [0.6, 0.6, 0.6],
          visibleInWorld: 'spectral',
          interactableInWorld: 'spectral',
          properties: {},
        },
        // Rocks for atmosphere
        {
          id: 'obj_temple_rocks',
          name: 'Décombres',
          type: 'static',
          modelId: 'rocks',
          position: [6, 0, 12],
          rotation: [0, 0.5, 0],
          scale: [1.2, 1, 1.2],
          visibleInWorld: 'both',
          interactableInWorld: 'both',
          properties: {},
        },
        // === Additional decorations for enlarged temple (30x30) ===
        // More pillars around the temple
        {
          id: 'obj_temple_pillar_5',
          name: 'Pilier du Temple',
          type: 'static',
          modelId: 'pillar',
          position: [26, 0, 4],
          rotation: [0, 0, 0],
          scale: [1.2, 1.5, 1.2],
          visibleInWorld: 'both',
          interactableInWorld: 'both',
          properties: { height: 6 },
        },
        {
          id: 'obj_temple_pillar_6',
          name: 'Pilier du Temple',
          type: 'static',
          modelId: 'pillar',
          position: [26, 0, 26],
          rotation: [0, 0, 0],
          scale: [1.2, 1.5, 1.2],
          visibleInWorld: 'both',
          interactableInWorld: 'both',
          properties: { height: 6 },
        },
        {
          id: 'obj_temple_pillar_7',
          name: 'Pilier Brisé',
          type: 'static',
          modelId: 'column',
          position: [20, 0, 10],
          rotation: [0, 0, 0],
          scale: [1, 0.7, 1],
          visibleInWorld: 'both',
          interactableInWorld: 'both',
          properties: {},
        },
        {
          id: 'obj_temple_pillar_8',
          name: 'Colonne',
          type: 'static',
          modelId: 'column',
          position: [8, 0, 24],
          rotation: [0, 0.3, 0],
          scale: [1.1, 1.1, 1.1],
          visibleInWorld: 'both',
          interactableInWorld: 'both',
          properties: {},
        },
        // Torch stands for lighting
        {
          id: 'obj_temple_torch_1',
          name: 'Torchère',
          type: 'static',
          modelId: 'torch_stand',
          position: [4, 0, 8],
          rotation: [0, 0, 0],
          scale: [1.2, 1.2, 1.2],
          visibleInWorld: 'both',
          interactableInWorld: 'both',
          properties: {},
        },
        {
          id: 'obj_temple_torch_2',
          name: 'Torchère',
          type: 'static',
          modelId: 'torch_stand',
          position: [22, 0, 6],
          rotation: [0, 0, 0],
          scale: [1.2, 1.2, 1.2],
          visibleInWorld: 'both',
          interactableInWorld: 'both',
          properties: {},
        },
        {
          id: 'obj_temple_torch_3',
          name: 'Torchère',
          type: 'static',
          modelId: 'torch_stand',
          position: [18, 0, 22],
          rotation: [0, 0, 0],
          scale: [1.2, 1.2, 1.2],
          visibleInWorld: 'both',
          interactableInWorld: 'both',
          properties: {},
        },
        {
          id: 'obj_temple_torch_4',
          name: 'Torchère',
          type: 'static',
          modelId: 'torch_stand',
          position: [6, 0, 26],
          rotation: [0, 0, 0],
          scale: [1.2, 1.2, 1.2],
          visibleInWorld: 'both',
          interactableInWorld: 'both',
          properties: {},
        },
        // Altars
        {
          id: 'obj_temple_altar_1',
          name: 'Autel',
          type: 'static',
          modelId: 'altar',
          position: [24, 0, 14],
          rotation: [0, -Math.PI / 2, 0],
          scale: [1, 1, 1],
          visibleInWorld: 'both',
          interactableInWorld: 'both',
          properties: {},
        },
        {
          id: 'obj_temple_altar_2',
          name: 'Petit Autel',
          type: 'static',
          modelId: 'altar',
          position: [12, 0, 28],
          rotation: [0, Math.PI, 0],
          scale: [0.8, 0.8, 0.8],
          visibleInWorld: 'both',
          interactableInWorld: 'both',
          properties: {},
        },
        // Banners on walls
        {
          id: 'obj_temple_banner_1',
          name: 'Bannière',
          type: 'static',
          modelId: 'banner',
          position: [0.5, 2, 12],
          rotation: [0, Math.PI / 2, 0],
          scale: [1, 1.5, 1],
          visibleInWorld: 'both',
          interactableInWorld: 'both',
          properties: {},
        },
        {
          id: 'obj_temple_banner_2',
          name: 'Bannière',
          type: 'static',
          modelId: 'banner',
          position: [29.5, 2, 18],
          rotation: [0, -Math.PI / 2, 0],
          scale: [1, 1.5, 1],
          visibleInWorld: 'both',
          interactableInWorld: 'both',
          properties: {},
        },
        // Statues
        {
          id: 'obj_temple_statue_1',
          name: 'Statue du Gardien',
          type: 'static',
          modelId: 'statue',
          position: [20, 0, 2],
          rotation: [0, Math.PI, 0],
          scale: [1.2, 1.4, 1.2],
          visibleInWorld: 'both',
          interactableInWorld: 'both',
          properties: {},
        },
        {
          id: 'obj_temple_statue_2',
          name: 'Statue Ancienne',
          type: 'static',
          modelId: 'statue',
          position: [28, 0, 20],
          rotation: [0, -Math.PI / 4, 0],
          scale: [1, 1.2, 1],
          visibleInWorld: 'both',
          interactableInWorld: 'both',
          properties: {},
        },
        // Debris and rocks
        {
          id: 'obj_temple_debris_1',
          name: 'Débris',
          type: 'static',
          modelId: 'debris',
          position: [16, 0, 18],
          rotation: [0, 0.8, 0],
          scale: [1.3, 1, 1.3],
          visibleInWorld: 'both',
          interactableInWorld: 'both',
          properties: {},
        },
        {
          id: 'obj_temple_debris_2',
          name: 'Débris',
          type: 'static',
          modelId: 'debris',
          position: [24, 0, 8],
          rotation: [0, 2.1, 0],
          scale: [1.1, 1, 1.1],
          visibleInWorld: 'both',
          interactableInWorld: 'both',
          properties: {},
        },
        {
          id: 'obj_temple_rock_1',
          name: 'Rocher',
          type: 'static',
          modelId: 'rock',
          position: [10, 0, 20],
          rotation: [0, 1.2, 0],
          scale: [1, 0.8, 1],
          visibleInWorld: 'both',
          interactableInWorld: 'both',
          properties: {},
        },
        {
          id: 'obj_temple_rock_2',
          name: 'Rocher',
          type: 'static',
          modelId: 'rock',
          position: [26, 0, 12],
          rotation: [0, 2.5, 0],
          scale: [0.9, 0.7, 0.9],
          visibleInWorld: 'both',
          interactableInWorld: 'both',
          properties: {},
        },
        // Candles clusters
        {
          id: 'obj_temple_candles_1',
          name: 'Bougies',
          type: 'static',
          modelId: 'candles',
          position: [8, 0.5, 8],
          rotation: [0, 0, 0],
          scale: [1.2, 1.2, 1.2],
          visibleInWorld: 'both',
          interactableInWorld: 'both',
          properties: {},
        },
        {
          id: 'obj_temple_candles_2',
          name: 'Bougies',
          type: 'static',
          modelId: 'candles',
          position: [22, 0, 24],
          rotation: [0, 0.5, 0],
          scale: [1, 1, 1],
          visibleInWorld: 'both',
          interactableInWorld: 'both',
          properties: {},
        },
        // Rugs
        {
          id: 'obj_temple_rug_1',
          name: 'Tapis',
          type: 'static',
          modelId: 'rug',
          position: [8, 0.02, 8],
          rotation: [0, Math.PI / 4, 0],
          scale: [2, 1, 2],
          visibleInWorld: 'both',
          interactableInWorld: 'both',
          properties: {},
        },
        {
          id: 'obj_temple_rug_2',
          name: 'Tapis',
          type: 'static',
          modelId: 'rug',
          position: [20, 0.02, 16],
          rotation: [0, 0, 0],
          scale: [1.5, 1, 2.5],
          visibleInWorld: 'both',
          interactableInWorld: 'both',
          properties: {},
        },
        // Cauldron
        {
          id: 'obj_temple_cauldron',
          name: 'Chaudron',
          type: 'static',
          modelId: 'cauldron',
          position: [4, 0, 22],
          rotation: [0, 0, 0],
          scale: [1.2, 1.2, 1.2],
          visibleInWorld: 'both',
          interactableInWorld: 'both',
          properties: {},
        },
        // Weapon rack
        {
          id: 'obj_temple_weapons',
          name: 'Râtelier d\'Armes',
          type: 'static',
          modelId: 'weapon_rack',
          position: [28, 0, 6],
          rotation: [0, -Math.PI / 2, 0],
          scale: [1, 1, 1],
          visibleInWorld: 'both',
          interactableInWorld: 'both',
          properties: {},
        },
        // === SECRET GUARDIAN - REQUIRES HIDDEN ITEM FROM LEVEL 3 ===
        // Ce gardien secret donne un bonus si le joueur a trouvé le Fragment d'Ombre caché dans les ruines
        {
          id: 'obj_secret_guardian',
          name: 'Gardien des Secrets',
          type: 'interactive',
          modelId: 'spectral_remnant',
          position: [26, 0, 24],
          rotation: [0, -Math.PI / 2, 0],
          scale: [1.4, 1.4, 1.4],
          visibleInWorld: 'spectral',
          interactableInWorld: 'spectral',
          properties: {},
          onInteract: [
            {
              type: 'requireItem',
              params: {
                itemId: 'shadow_fragment',
                missingMessage: '"Voyageur des ombres... Je sens que tu as traversé les ruines, mais tu n\'as pas trouvé ce que j\'attends. Retourne parmi les tombes des anciens... Cherche dans le voile..."',
              },
            },
            {
              type: 'showMessage',
              params: {
                message: '"Tu as trouvé le Fragment d\'Ombre ! Les anciens t\'ont jugé digne..."',
              },
            },
            {
              type: 'giveItem',
              params: {
                itemId: 'shadow_fragment',
                npcId: 'obj_secret_guardian',
                successMessage: '"Je prends ce fragment pour le réunir avec les autres. En échange, accepte ce don des ténèbres..."',
              },
            },
            {
              type: 'addToInventory',
              params: {
                itemId: 'shadow_essence',
                itemName: 'Essence des Ténèbres',
                itemDescription: 'Une essence pure de l\'ombre. Elle augmente ton affinité avec le monde spectral.',
                itemIcon: 'orb',
              },
            },
            {
              type: 'showMessage',
              params: {
                message: '"L\'Essence des Ténèbres est tienne. Peu de voyageurs trouvent ce secret. Tu es spécial, gardien du voile."',
              },
            },
            {
              type: 'hideObject',
              params: {
                objectId: 'obj_secret_guardian',
              },
            },
          ],
        },
        // More spectral orbs
        {
          id: 'obj_shadow_orb_3',
          name: 'Orbe d\'Ombre',
          type: 'static',
          modelId: 'orb',
          position: [18, 2.5, 10],
          rotation: [0, 0, 0],
          scale: [0.5, 0.5, 0.5],
          visibleInWorld: 'spectral',
          interactableInWorld: 'spectral',
          properties: {},
        },
        {
          id: 'obj_shadow_orb_4',
          name: 'Orbe d\'Ombre',
          type: 'static',
          modelId: 'orb',
          position: [6, 1.8, 20],
          rotation: [0, 0, 0],
          scale: [0.4, 0.4, 0.4],
          visibleInWorld: 'spectral',
          interactableInWorld: 'spectral',
          properties: {},
        },
        {
          id: 'obj_shadow_orb_5',
          name: 'Orbe d\'Ombre',
          type: 'static',
          modelId: 'orb',
          position: [26, 2.2, 24],
          rotation: [0, 0, 0],
          scale: [0.45, 0.45, 0.45],
          visibleInWorld: 'spectral',
          interactableInWorld: 'spectral',
          properties: {},
        },
      ],
      puzzles: [
        {
          id: 'puzzle_shadow_sequence',
          name: 'La Séquence des Ombres',
          type: 'sequence',
          state: 'active',
          description: 'Active les dalles dans le bon ordre pour ouvrir le sanctuaire.',
          hint: 'Les gardiens des deux mondes connaissent chacun une partie de la séquence.',
          linkedObjectIds: ['obj_plate_1', 'obj_plate_2', 'obj_plate_3'],
          solution: {
            type: 'sequence',
            expected: ['obj_plate_1', 'obj_plate_2', 'obj_plate_3'],
          },
          onSolve: [
            {
              type: 'showMessage',
              params: {
                message: 'La séquence est complète ! Les ombres dansent de joie.',
              },
            },
          ],
        },
      ],
      connections: [
        {
          targetRoomId: 'room_ancient_ruins',
          position: [0, 0, 8],
          direction: 'west',
          locked: false,
        },
        {
          targetRoomId: 'room_crystal_labyrinth',
          position: [16, 0, 8],
          direction: 'east',
          locked: false,
        },
      ],
      initialWorld: 'real',
      hasSpectralLayer: true,
      palette: 'shadow',
      biome: 'swamp',
      weather: 'fog',
      weatherIntensity: 0.6,
      npcs: [
        {
          id: 'npc_frog_1',
          type: 'frog',
          name: 'Grenouille Vénérable',
          position: [10, 0, 18],
          scale: 3,
          idleAnimation: 'sit',
          petAnimation: 'jump',
          petRadius: 2.5,
          petCooldown: 2000,
          isPettable: true,
          visibleInWorld: 'both',
        },
        {
          id: 'npc_frog_2',
          type: 'frog',
          name: 'Petite Grenouille',
          position: [6, 0, 22],
          scale: 2.5,
          idleAnimation: 'sit',
          petAnimation: 'jump',
          petRadius: 2,
          petCooldown: 1800,
          isPettable: true,
          visibleInWorld: 'both',
        },
        {
          id: 'npc_heron_1',
          type: 'heron',
          name: 'Héron Majestueux',
          position: [20, 0, 12],
          scale: 3.5,
          idleAnimation: 'stand',
          petAnimation: 'nuzzle',
          petRadius: 3,
          petCooldown: 3500,
          isPettable: true,
          visibleInWorld: 'both',
        },
        {
          id: 'npc_crocodile_1',
          type: 'crocodile',
          name: 'Crocodile Ancien',
          position: [16, 0, 24],
          scale: 3.5,
          idleAnimation: 'sleep',
          petAnimation: 'happy',
          petRadius: 4,
          petCooldown: 5000,
          isPettable: true,
          visibleInWorld: 'both',
        },
        {
          id: 'npc_firefly_1',
          type: 'firefly',
          name: 'Luciole Spectrale',
          position: [24, 1.5, 16],
          scale: 3,
          idleAnimation: 'fly',
          petAnimation: 'spin',
          petRadius: 2,
          petCooldown: 1500,
          isPettable: true,
          visibleInWorld: 'both',
        },
        {
          id: 'npc_duck_1',
          type: 'duck',
          name: 'Canard Paisible',
          position: [6, 0, 14],
          scale: 3,
          idleAnimation: 'swim',
          petAnimation: 'happy',
          petRadius: 2.5,
          petCooldown: 2000,
          isPettable: true,
          visibleInWorld: 'both',
        },
      ],
};
